import React from "react";
import { BarChart } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts';

function CorrispettiviMese({
    data,
    titolo,
    displayTitolo
}) {

    const chartSetting = {
        yAxis: [
            {
                label: 'Importo (€)'
            }
            
        ],
        disableTicks: true,
        width: 600,
        height: 300,
        sx: {
            [`.${axisClasses.left} .${axisClasses.label}`]: {
                transform: 'rotate(-90deg) translate(0px, -20px)',
            },
        }
    };

    let dataset = [];

    if (data.risultatiQueryStati) {
        dataset = data.risultatiQueryStati;
    }
    console.log("dataset", dataset)

    const valueFormatter = (value) => value ? value : 0;

    let series = [];

    if (data.anni && data.anni.length > 1) {
        console.log("data.anni", data.anni)
        data.anni.forEach(anno => {
            
                series.push({ dataKey: anno, label: anno, valueFormatter })
            

        })
    }

    console.log("series", series)

    if (data) {
        return (
            <div>
                {titolo && displayTitolo && <div className="tc sfondoColChiaro pa2 b">{titolo}</div>}
                {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
                <div className="pa2 flex flex-wrap items-center">
                    <BarChart
                        dataset={dataset}
                        xAxis={[{ scaleType: 'band', dataKey: 'nazione' }]}
                        series={series}
                        {...chartSetting}
                    />
                </div>
            </div>
        )
    } else {
        return (<div>no data</div>)
    }

}

export default CorrispettiviMese;